import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function NewsletterForm({ source = "home", testid = "newsletter-form", compact = false }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email, source });
      setDone(true);
      toast.success("Signal locked. You are on the list.");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Failed");
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <div className="label-accent" data-testid={`${testid}-success`}>
        ✓ Subscribed — listen for the next transmission.
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      data-testid={testid}
      className={compact ? "flex gap-2" : "flex flex-col sm:flex-row gap-3"}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="your.email@signal"
        data-testid={`${testid}-input`}
        className="nccc-input flex-1"
      />
      <button
        type="submit"
        disabled={busy}
        data-testid={`${testid}-submit`}
        className="nccc-btn"
      >
        {busy ? "Locking..." : "Join the signal"}
      </button>
    </form>
  );
}
